import Modal from "global/Modal/Modal";
import SimpleButton from "global/SimpleButton/SimpleButton";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { usePayment } from "./utils/usePayment";
import CountdownTimer from "components/count-down";
import { hasPermission } from "utils/HasPermission";
import LinkPayment from "global/link-payment";
import { useLocation, useNavigate } from "react-router-dom";
import { usePayByWallet } from "global/payment/wallet-payment";
import { RiBankCardLine } from "react-icons/ri";

import PosPaymentInquiry from "./pos-payment-inquiry";

const PaymentModal = ({ isOpen, setIsOpen, isIdentityOrder }) => {
  const { orderData } = useSelector((state: any) => state.Order);
  const { orderManagementData } = useSelector((state: any) => state.orderData);
  const [openLinkPayment, setOpenLinkPayment] = useState(false);
  const { state } = useLocation();
  const [posPaymentInquiry, setPosPaymentInquiry] = useState({
    show: false,
    status: "",
  });
  const { payByWallet, loading: loadingWallet } = usePayByWallet();
  const navigate = useNavigate();
  const {
    handleClick,
    setIsLoading,
    isLoading,
    isLoadingPos,
    setIsLoadingPos,
    time,
  } = usePayment();
  const [startCountDown, setStartCountDown] = useState(false);

  useEffect(() => {
    !isOpen && setIsLoading(false);
    setIsLoadingPos(false);
  }, [isOpen]);

  const formatPrice = (price) => {
    return price?.toLocaleString() || "---";
  };

  function disablePosPayment() {
    setPosPaymentInquiry({ show: false, status: "" });
    setStartCountDown(false);
  }

  return (
    <Modal visible={isOpen} setVisible={setIsOpen} title="انتخاب روش پرداخت">
      {/* Price Display Section */}
      <div className="0 p-6 rounded-xl border border-tomato mb-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-tomato rounded-full flex items-center justify-center">
              <RiBankCardLine className="w-6 h-6 text-white" />
            </div>
            <span className="text-gray-700 font-medium text-lg">
              مبلغ قابل پرداخت:
            </span>
          </div>
          <div className="text-left">
            <span className="text-2xl font-bold text-gray-900">
              {formatPrice(orderData?.tashimPrice?.totalAmount)}
            </span>
            <span className="text-sm text-gray-500 mr-2">ریال</span>
          </div>
        </div>
      </div>

      {/* Payment Methods Section */}
      <div className="space-y-6">
        <h3 className="text-lg font-semibold text-gray-800 border-r-4 border-tomato pr-4">
          روش‌های پرداخت موجود
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    
            <div className="group transform transition-transform hover:scale-105">
              <SimpleButton
                text="پرداخت اعتباری"
                loading={isLoading}
                className="w-full h-16 bg-gradient-to-r from-tomato to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold rounded-xl border-0 shadow-lg hover:shadow-xl transition-all duration-300"
                rightIcon={<RiBankCardLine className="w-6 h-6" />}
                handelClick={() => {
                  handleClick(false, orderData);
                  disablePosPayment();
                }}
                disabled={isLoadingPos || isLoading}
              />
            </div>
        

          {/* POS Payment */}
          {!isIdentityOrder && 
          
          <div className="group transform transition-transform hover:scale-105">
            <SimpleButton
              text="پرداخت کارتخوان"
              loading={isLoadingPos}
              className="w-full h-16 bg-gradient-to-r from-tomato to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold rounded-xl border-0 shadow-lg hover:shadow-xl transition-all duration-300"
              rightIcon={<RiBankCardLine className="w-6 h-6" />}
              handelClick={() => {
                handleClick(true, orderData);
                setStartCountDown(true);
                setPosPaymentInquiry({ show: true, status: "" });
              }}
              disabled={isLoadingPos || isLoading}
            />
          </div>
          }

          
          {hasPermission("add_order_payment_link") && !isIdentityOrder && (
            <div className="group transform transition-transform hover:scale-105">
              <SimpleButton
                text="پرداخت از طریق لینک"
                loading={isLoading}
                className="w-full h-16 bg-gradient-to-r  from-tomato to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold rounded-xl border-0 shadow-lg hover:shadow-xl transition-all duration-300"
                rightIcon={<RiBankCardLine className="w-6 h-6" />}
                handelClick={() => {
                  setOpenLinkPayment(true);
                  disablePosPayment();
                }}
                disabled={isLoadingPos || isLoading}
              />
            </div>
          )}

          {/* Wallet Payment */}
          {hasPermission("payment_from_customer__wallet") && !isIdentityOrder && (
            <div className="group transform transition-transform hover:scale-105">
              <SimpleButton
                text="پرداخت از کیف پول مشتری"
                loading={loadingWallet}
                className="w-full h-16 bg-gradient-to-r from-tomato to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold rounded-xl border-0 shadow-lg hover:shadow-xl transition-all duration-300"
                rightIcon={<RiBankCardLine className="w-6 h-6" />}
                handelClick={() => {
                  payByWallet(
                    orderManagementData?.orderId,
                    orderData?.tashimPrice?.totalAmount
                  );
                  disablePosPayment();
                }}
                disabled={loadingWallet || isLoadingPos}
              />
            </div>
          )}
        </div>
      </div>

      {/* Payment Guide */}
      <div className="mt-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
        <div className="flex items-start gap-3">
          <div className="w-2 h-2 bg-tomato rounded-full mt-2 flex-shrink-0"></div>
          <div className="text-sm text-gray-600">
            <p className="font-medium mb-1">راهنمای پرداخت:</p>
            <ul className="space-y-1 text-xs">
              <li>• پرداخت اعتباری: پرداخت از اعتبار هاب</li>
              <li>• پرداخت کارتخوان: پرداخت با کارت بانکی مشتری</li>
              <li>• پرداخت لینکی: ارسال لینک پرداخت به مشتری</li>
              <li>• کیف پول: پرداخت از موجودی کیف پول مشتری</li>
            </ul>
          </div>
        </div>
      </div>

      {posPaymentInquiry.show && (
        <PosPaymentInquiry orderId={orderManagementData?.orderId} />
      )}
      {startCountDown && (
        <div className="mt-6 p-4 bg-gradient-to-r from-orange-50 to-red-50 border border-orange-200 rounded-xl">
          <div className="flex items-center gap-3 mb-3">
            <div className="flex space-x-1">
              <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
              <div
                className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"
                style={{ animationDelay: "0.2s" }}
              ></div>
              <div
                className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"
                style={{ animationDelay: "0.4s" }}
              ></div>
            </div>
            <span className="text-orange-800 font-semibold">
              در انتظار تایید پرداخت...
            </span>
          </div>
          <div className="bg-white p-3 rounded-lg shadow-sm">
            <CountdownTimer initialTime={time} />
          </div>
        </div>
      )}

      {/* Link Payment Modal */}
      <LinkPayment
        open={openLinkPayment}
        setOpen={setOpenLinkPayment}
        payData={{
          mobile: orderManagementData?.mobile,
          price: orderData?.tashimPrice?.totalAmount,
          orderId: orderManagementData?.orderId,
        }}
        api={"/consignment-api/payments/payment-links/orders/payment"}
        type="order"
        callBack={() => {
          state?.orderReceipt
            ? navigate("/order-receipt")
            : navigate("/order-management");
        }}
      />
    </Modal>
  );
};

export default PaymentModal;
